/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, deleteData } from "utils/Gateway";

import AddEditEducationModal from "components/Common/Modal/AddEditEducationModal";
import AddEditExperienceModal from "components/Common/Modal/AddEditExperienceModal";
import AfterSaveUserModal from "components/Common/Modal/AfterSaveUserModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import {
  appUserHeaderLinks,
  appUserProfileLink,
} from "helper/AppUserHelper/AppUserHelper";
import AddEditCetificateModal from "components/Common/Modal/AddEditCetificateModal";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import AddEditSkillPointModal from "components/Common/Modal/AddEditSkillPointModal";
import AddEditPortfolioLinkModal from "components/Common/Modal/AddEditPortfolioLinkModal";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

const AppUserCvBody = () => {
  const { t } = useTranslation(); //for translation

  const params = useParams();
  const history = useHistory();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const commonHeaderObject = appUserHeaderLinks(params.id, t);

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("App User"), link: appUserProfileLink },
    { title: t("CV") },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");

  const [summary, setSummary] = useState("");

  /* ----- skill point block requirement start ------*/
  const [skillPointData, setSkillPointData] = useState({
    skill: null,
    skillvalue: null,
    skillname: "",
    points: "",
    experienceyear: "",
  });
  const [skillPointListBlock, setSkillPointListBlock] = useState([]);
  const [skillPointIndex, setSkillPointIndex] = useState(null);
  /* ----- skill point block requirement end ------*/

  /* ----- education block requirement start ------*/
  const [educationData, setEducationData] = useState({
    degree: "",
    year: "",
    grade: "",
    institute: "",
  });
  const [educationListBlock, setEducationListBlock] = useState([]);
  const [educationIndex, setEducationIndex] = useState(null);
  /* ----- education block requirement end ------*/

  /* ----- experience block requirement start ------*/
  const [experienceData, setExperienceData] = useState({
    companyid: null,
    company: "",
    position: "",
    start: "",
    end: "",
    ctc: "",
    responsibilities: "",
  });
  const [experienceListBlock, setExperienceListBlock] = useState([]);
  const [experienceIndex, setExperienceIndex] = useState(null);
  /* ----- experience block requirement end ------*/

  /* ----- Certificates block requirement start ------*/
  const [technicalExperienceData, settechnicalExperienceData] = useState({
    name: "",
    companyvalue: null,
    companyname: "",
    start: "",
    end: "",
    description: "",
    grade: "",
  });
  const [technicalExpBlock, settechnicalExpBlock] = useState([]);
  const [technicalExpIndex, settechnicalExpIndex] = useState(null);
  /* ----- Certificates block requirement end ------*/

  /* ----- portfoilio requiremnet start -----*/
  const [portfolioData, setPortfolioData] = useState("");
  const [portfolioBlock, setPortfolioBlock] = useState([]);
  const [portfolioIndex, setPortfolioIndex] = useState(null);
  /* ----- portfoilio requiremnet end -----*/

  //requriement for right panel
  const [userEducations, setuserEducations] = useState([]);
  const [userExperiences, setuserExperiences] = useState([]);
  const [userCertificates, setuserCertificates] = useState([]);

  //out of field requirements
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [website, setWebsite] = useState("");
  const [rate, setRate] = useState("");
  const [address, setAddress] = useState("");

  //function for get all company list
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_LIST + `?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for edit eduction block
  const updateEductionBlock = (education, index) => {
    setEducationIndex(index);
    setEducationData(education);
  };

  //function for delete eduction block
  const onDeleteEducationBlock = (index) => {
    const filteredEducationBlock = [...educationListBlock];
    filteredEducationBlock.splice(index, 1);
    setEducationListBlock(filteredEducationBlock);
  };

  //function for view education blocks
  const getEducationBlock = (educations) => {
    const educationArr = educations.map((education) => {
      return {
        _id: education?._id,
        degree: education?.degree,
        grade: education?.grade,
        year: education?.year,
        institute: education?.institute,
      };
    });
    setEducationListBlock(educationArr);
  };

  //function for edit experience block
  const updateExperienceBlock = (experience, index) => {
    setExperienceIndex(index);
    setExperienceData(experience);
  };

  //function for delete experience block
  const onDeleteExperienceBlock = (index) => {
    const filteredExperienceBlock = [...experienceListBlock];
    filteredExperienceBlock.splice(index, 1);
    setExperienceListBlock(filteredExperienceBlock);
  };

  //function for view experience blocks
  const getExperienceBlock = (experiences) => {
    const experienceArr = experiences.map((experience) => {
      const expSavedData = {
        _id: experience?._id,
        companyid: experience.companyid,
        company: experience?.company,
        end: experience?.end,
        position: experience?.position,
        start: experience?.start,
        ctc: experience?.ctc,
        responsibilities: experience?.responsibilities,
      };
      return expSavedData;
    });

    setExperienceListBlock(experienceArr);
  };

  //function for edit technical experence block
  const updateTechnicalExpBlock = (techExp, index) => {
    settechnicalExperienceData(techExp);
    settechnicalExpIndex(index);
  };

  //delete tech exp block
  const onDeleteTechExpBlock = (index) => {
    const filteredTechExpBlock = [...technicalExpBlock];
    filteredTechExpBlock.splice(index, 1);
    settechnicalExpBlock(filteredTechExpBlock);
  };

  //function for view tech exp blocks
  const getTechExpBlock = (techExp) => {
    const techExpArr = techExp.map((techExpData) => {
      const companyvalue = {
        label: techExpData?.companyname,
        value: techExpData?.companyname,
      };
      const certificateSavedData = {
        _id: techExpData?._id,
        name: techExpData?.name,
        companyname: techExpData?.companyname,
        companyvalue,
        start: techExpData?.start,
        end: techExpData?.end,
        description: techExpData?.description,
        grade: techExpData?.grade,
      };

      return certificateSavedData;
    });

    settechnicalExpBlock(techExpArr);
  };

  //update skillpoint block
  const updateSkillPointBlock = (skillpoint, index) => {
    setSkillPointIndex(index);
    setSkillPointData(skillpoint);
  };

  //function for delete skillpoint block
  const onDeleteSkillPointBlock = (index) => {
    const filteredSkillPointBlock = [...skillPointListBlock];
    filteredSkillPointBlock.splice(index, 1);
    setSkillPointListBlock(filteredSkillPointBlock);
  };

  //function for view skillpoint blocks
  const getSkillPointsBlock = (skillPoints) => {
    const skillPintArr = skillPoints.map((skillPoint) => {
      let skillPointSavedData = {
        _id: skillPoint?._id,
        skill: skillPoint?.skill,
        skillvalue: skillPoint?.skillvalue,
        skillname: skillPoint?.skillname,
        points: skillPoint?.points,
        experienceyear: skillPoint?.experienceyear,
      };
      return skillPointSavedData;
    });
    setSkillPointListBlock(skillPintArr);
  };

  //function for edit eduction block
  const updatePortfolioBlock = (portfolio, index) => {
    setPortfolioIndex(index);
    setPortfolioData(portfolio);
  };

  //function for delete eduction block
  const onDeletePortfolioBlock = (index) => {
    const filteredPortfolioBlock = [...portfolioBlock];
    filteredPortfolioBlock.splice(index, 1);
    setPortfolioBlock(filteredPortfolioBlock);
  };

  //function for get user details
  const getAppUserDetails = async () => {
    const userPublicIp = await getPublicIP();
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}` +
        `?token=${token}&userip=${userPublicIp}`;

      const response = await getData(requestUrl);
      setIsLoading(false);
      if (response.status && response.data) {
        const data = response.data;
        setName(data.name || "");
        setSurName(data.surname || "");
        setTelephone(data.phone ?? "");
        setPosition(data.position ?? "");
        setAddress(data.address || "");
        setWebsite(data.website || "");
        setRate(data.costperhour || "");
        setstateName(data.state || "");
        setcityName(data.city || "");
        setcountry(data.country || "");
        setzipcode(data.zipcode || "");
        setSummary(data.summary || "");
        getEducationBlock(data.educationids);
        setuserEducations(data.educationids);
        getExperienceBlock(data.experienceids);
        setuserExperiences(data.experienceids);
        getTechExpBlock(data.certifications);
        setPortfolioBlock(data.portfoliolink || []);

        if (response.data.skillpointidsextended.length > 0) {
          getSkillPointsBlock(data.skillpointidsextended);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save/update user
  const saveUserHandler = async () => {
    const userPublicIp = await getPublicIP();
    try {
      setIsSending(true);
      let userData = {
        position,
        phone: telephone,
        address,
        city: cityName,
        state: stateName,
        country,
        zipcode,
        costperhour: rate,
        website,
        summary,
        educations: educationListBlock,
        experiences: experienceListBlock,
        certifications: technicalExpBlock,
        skillpointids: skillPointListBlock,
        portfoliolink: portfolioBlock,
      };
      let requestUrl = url.API_BASE_URL;
      let response = {};
      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_APP_USER +
          `/${params.id}` +
          `?token=${token}&userip=${userPublicIp}`;
        response = await putData(requestUrl, userData);
      }
      setIsSending(false);
      if (response.status) {
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveUserModal")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for afterSaveModalClose
  const afterSaveModalClose = (pageName) => {
    if (pageName == "details") {
      getAppUserDetails();
    } else {
      history.push("/admin/appuser/list");
    }
  };

  useEffect(() => {
    if (params.id) {
      getAllCompanyList();
      getAppUserDetails();
    }
  }, [params.id]);

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("CV")}
          />
        )}
        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={`${name} ${surName}`}
          />
          <div className="row">
            <div className="col-lg-9 mb-4 mb-lg-0">
              <div className="p-3 p-lg-4 border h-100 rounded-10 shadow-sm">
                <div className="mb-5">
                  <h3 className="fw-bold mb-3">{t("Summary")}</h3>
                  <div className="form-group">
                    <textarea
                      className="form-control border border-gray-300"
                      rows={6}
                      placeholder={t(
                        "Brief about your experience (in 150 characters)..."
                      )}
                      value={summary}
                      onChange={(e) => setSummary(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item bg-transparent border-0 mb-5">
                    <h2 className="accordion-header mb-3">
                      <button
                        className="accordion-button bg-transparent p-0 shadow-none h3 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseSix"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseSix"
                      >
                        {t("Skill Points")}
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseSix"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body p-0">
                        <div className="fields-group">
                          <div className="fields d-flex flex-column gap-3">
                            {skillPointListBlock.map((skillBlock, index) => (
                              <div className="field" key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-lg-4">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Skill")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {skillBlock?.skillname}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Point")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {skillBlock.points}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Total Experience")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {skillBlock.experienceyear}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                                    <Link
                                      to="#"
                                      className="text-secondary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#addSkillPointModal"
                                      onClick={() =>
                                        updateSkillPointBlock(skillBlock, index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        edit
                                      </span>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn p-0 border-0 bg-transparent text-danger"
                                      onClick={() =>
                                        onDeleteSkillPointBlock(index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#addSkillPointModal"
                            onClick={() => setSkillPointIndex(null)}
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 mt-3"
                          >
                            <span className="d-block material-symbols-outlined">
                              add
                            </span>
                            <span className="d-block fw-semibold">
                              {t("Add Skill Points")}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item bg-transparent border-0 mb-5">
                    <h2 className="accordion-header mb-3">
                      <button
                        className="accordion-button bg-transparent p-0 shadow-none h3 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseThree"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseThree"
                      >
                        {t("Education")}
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseThree"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body p-0">
                        <div className="fields-group">
                          <div className="fields d-flex flex-column gap-3">
                            {educationListBlock.map((education, index) => (
                              <div className="field" key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Degree")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {education.degree}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Year")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {education.year}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Grade")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {education.grade}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Institute")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {education.institute}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                                    <Link
                                      to="#"
                                      className="text-secondary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#addEducationModal"
                                      onClick={() =>
                                        updateEductionBlock(education, index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        edit
                                      </span>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn p-0 border-0 bg-transparent text-danger"
                                      onClick={() =>
                                        onDeleteEducationBlock(index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <Link
                            to="#"
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 mt-3"
                            data-bs-toggle="modal"
                            data-bs-target="#addEducationModal"
                            onClick={() => setEducationIndex(null)}
                          >
                            <span className="d-block material-symbols-outlined">
                              add
                            </span>
                            <span className="d-block fw-semibold">
                              {t("Add Education")}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item bg-transparent border-0 mb-5">
                    <h2 className="accordion-header mb-3">
                      <button
                        className="accordion-button bg-transparent p-0 shadow-none h3 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseFour"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseFour"
                      >
                        {t("Experience")}
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseFour"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body p-0">
                        <div className="fields-group">
                          <div className="fields d-flex flex-column gap-3">
                            {experienceListBlock.map((experience, index) => (
                              <div className="field" key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Company")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {experience.companyid
                                          ? experience.companyid.label
                                          : experience.company}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Position")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {experience.position}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Start Year")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {experience.start}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("To Year")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {experience.end}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                                    <Link
                                      to="#"
                                      className="text-secondary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#addExperienceModal"
                                      onClick={() =>
                                        updateExperienceBlock(experience, index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        edit
                                      </span>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn p-0 border-0 bg-transparent text-danger"
                                      onClick={() =>
                                        onDeleteExperienceBlock(index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#addExperienceModal"
                            onClick={() => setExperienceIndex(null)}
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 mt-3"
                          >
                            <span className="d-block material-symbols-outlined">
                              add
                            </span>
                            <span className="d-block fw-semibold">
                              {t("Add Experience")}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item bg-transparent border-0 mb-5">
                    <h2 className="accordion-header mb-3">
                      <button
                        className="accordion-button bg-transparent p-0 shadow-none h3 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseFive"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseFive"
                      >
                        {t("Certificates")}
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseFive"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body p-0">
                        <div className="fields-group">
                          <div className="fields d-flex flex-column gap-3">
                            {technicalExpBlock.map((techExpData, index) => (
                              <div className="field" key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Course")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {techExpData.name}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Company")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                                        {techExpData.companyname}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("From")}
                                      </span>
                                      <p className="fw-bold ps-3 mb-0 text-dark">
                                        {getDateFormatInSpanish(
                                          techExpData.start
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("To")}
                                      </span>
                                      <p className="fw-bold ps-2 mb-0 text-dark">
                                        {getDateFormatInSpanish(
                                          techExpData.end
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                                    <Link
                                      to="#"
                                      className="text-secondary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#addCertificateModal"
                                      onClick={() =>
                                        updateTechnicalExpBlock(
                                          techExpData,
                                          index
                                        )
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        edit
                                      </span>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn p-0 border-0 bg-transparent text-danger"
                                      onClick={() =>
                                        onDeleteTechExpBlock(index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <Link
                            to="#"
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 mt-3"
                            data-bs-toggle="modal"
                            data-bs-target="#addCertificateModal"
                            onClick={() => settechnicalExpIndex(null)}
                          >
                            <span className="d-block material-symbols-outlined">
                              add
                            </span>
                            <span className="d-block fw-semibold">
                              {t("Add Certificate")}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item bg-transparent border-0 mb-5">
                    <h2 className="accordion-header mb-3">
                      <button
                        className="accordion-button bg-transparent p-0 shadow-none h3 fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapsePortfolio"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapsePortfolio"
                      >
                        {t("Portfolio Links")}
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapsePortfolio"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body p-0">
                        <div className="fields-group">
                          <div className="fields d-flex flex-column gap-3">
                            {portfolioBlock.map((portfolioBlockData, index) => (
                              <div className="field" key={index}>
                                <div className="row g-3 align-items-center">
                                  <div className="col-lg-11">
                                    <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                                      <span className="text-muted border-end py-3 px-3 lh-1">
                                        {t("Link")}
                                      </span>
                                      <a
                                        href={portfolioBlockData}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="fw-bold ps-3 mb-0 text-dark text-truncate d-block"
                                      >
                                        {portfolioBlockData}
                                      </a>
                                    </div>
                                  </div>
                                  <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                                    <Link
                                      to="#"
                                      className="text-secondary"
                                      data-bs-toggle="modal"
                                      data-bs-target="#savePortfolioLinkModal"
                                      onClick={() =>
                                        updatePortfolioBlock(
                                          portfolioBlockData,
                                          index
                                        )
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        edit
                                      </span>
                                    </Link>
                                    <button
                                      type="button"
                                      className="btn p-0 border-0 bg-transparent text-danger"
                                      onClick={() =>
                                        onDeletePortfolioBlock(index)
                                      }
                                    >
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <Link
                            to="#"
                            className="btn btn-outline-primary d-inline-flex align-items-center gap-2 mt-3"
                            data-bs-toggle="modal"
                            data-bs-target="#savePortfolioLinkModal"
                            onClick={() => setPortfolioIndex(null)}
                          >
                            <span className="d-block material-symbols-outlined">
                              add
                            </span>
                            <span className="d-block fw-semibold">
                              {t("Add Portfolio Link")}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5 action d-flex flex-wrap gap-3">
                  <button
                    className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                    onClick={saveUserHandler}
                    disabled={isSending}
                  >
                    {isSending ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <span className="d-block material-symbols-outlined">
                        save
                      </span>
                    )}
                    <span className="d-block fw-semibold">{t("Save CV")}</span>
                  </button>
                </div>
              </div>
            </div>

            {isLoading ? (
              <div className="col-lg-3">
                <div className="p-3 p-lg-4 border h-100 rounded-10 shadow-sm">
                  {/* Placeholder for Educations */}
                  <div className="mb-5">
                    <h5 className="fw-bold mb-3 pb-2 border-bottom">
                      {t("Educations")}
                    </h5>

                    {[...Array(2)].map((_, index) => (
                      <ul className="work-experience-flow" key={index}>
                        <li className="step position-relative active">
                          <p className="placeholder-glow mb-2">
                            <span className="placeholder col-6"></span>
                          </p>
                          <ul className="tags d-flex gap-2 flex-wrap fs-sm lh-1 mb-3">
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="placeholder col-4"></span>
                            </li>
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="placeholder col-3"></span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    ))}
                  </div>

                  {/* Placeholder for Experiences */}
                  <div className="mb-4">
                    <h5 className="fw-bold mb-3 pb-2 border-bottom">
                      {t("Experiences")}
                    </h5>

                    {[...Array(2)].map((_, index) => (
                      <ul className="work-experience-flow" key={index}>
                        <li className="step position-relative active">
                          <p className="placeholder-glow mb-2">
                            <span className="placeholder col-7"></span>
                          </p>
                          <ul className="tags d-flex gap-2 flex-wrap fs-sm lh-1 mb-3">
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="placeholder col-5"></span>
                            </li>
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="placeholder col-4"></span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-lg-3">
                <div className="p-3 p-lg-4 border h-100 rounded-10 shadow-sm">
                  <div className="mb-5">
                    <h5 className="fw-bold mb-3 pb-2 border-bottom">
                      {t("Educations")}
                    </h5>
                    {userEducations.map((education, index) => (
                      <ul className="work-experience-flow" key={index}>
                        <li className="step position-relative active">
                          <p className="fs-sm fw-semibold mb-2">
                            {education.degree}
                          </p>
                          <ul className="tags d-flex gap-2 flex-wrap fs-sm lh-1 mb-3">
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="d-block material-symbols-outlined icon-md">
                                school
                              </span>
                              <span className="d-block">
                                {education.institute}
                              </span>
                            </li>
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="d-block material-symbols-outlined icon-md">
                                event_note
                              </span>
                              <span className="d-block">{education.year}</span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    ))}
                  </div>
                  <div className="mb-4">
                    <h5 className="fw-bold mb-3 pb-2 border-bottom">
                      {t("Experiences")}
                    </h5>
                    {userExperiences.map((experience, index) => (
                      <ul className="work-experience-flow" key={index}>
                        <li className="step position-relative active">
                          <p className="fs-sm fw-semibold mb-2">
                            {experience.company}
                          </p>
                          <ul className="tags d-flex gap-2 flex-wrap fs-sm lh-1 mb-3">
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="d-block material-symbols-outlined icon-md">
                                store
                              </span>
                              <span className="d-block">
                                {experience.position}
                              </span>
                            </li>
                            <li className="tag d-flex align-items-center gap-2 gradient-light py-2 px-3 rounded-pill">
                              <span className="d-block material-symbols-outlined icon-md">
                                event_note
                              </span>
                              <span className="d-block">
                                {experience.start} - {experience.end}
                              </span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <AddEditSkillPointModal
          {...{
            setSkillPointData,
            setSkillPointIndex,
            setSkillPointListBlock,
            skillPointData,
            skillPointIndex,
            skillPointListBlock,
          }}
        />
        <AddEditEducationModal
          {...{
            educationIndex,
            setEducationIndex,
            educationData,
            setEducationData,
            educationListBlock,
            setEducationListBlock,
          }}
        />
        <AddEditExperienceModal
          {...{
            companyList,
            experienceData,
            setExperienceData,
            experienceListBlock,
            setExperienceListBlock,
            experienceIndex,
            setExperienceIndex,
          }}
        />
        <AddEditCetificateModal
          {...{
            technicalExpIndex,
            settechnicalExpIndex,
            technicalExperienceData,
            settechnicalExperienceData,
            technicalExpBlock,
            settechnicalExpBlock,
          }}
        />
        <AddEditPortfolioLinkModal
          {...{
            portfolioIndex,
            setPortfolioIndex,
            portfolioData,
            setPortfolioData,
            portfolioBlock,
            setPortfolioBlock,
          }}
        />
        <AfterSaveUserModal
          userId={params.id}
          afterSaveModalClose={afterSaveModalClose}
          moduleName={"CV"}
        />
        <DeleteWarningModal
          onCancelDelete={() => {
            setSkillPointIndex(null);
          }}
          onDelete={onDeleteSkillPointBlock}
          moduleName={t("skillpoint")}
        />
      </section>
    </div>
  );
};
export default AppUserCvBody;
